import { render, staticRenderFns } from "./GatButtonMenu.vue?vue&type=template&id=1076b5e8&scoped=true"
import script from "./GatButtonMenu.vue?vue&type=script&lang=js"
export * from "./GatButtonMenu.vue?vue&type=script&lang=js"
import style0 from "./GatButtonMenu.vue?vue&type=style&index=0&id=1076b5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1076b5e8",
  null
  
)

export default component.exports